// @ts-strict
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LMRouteComponentService } from '@services/index';
import {
  FieldOperatorChangedEvent,
  LMFieldOperatorOptionState,
  LMFormatStyleOptionState,
  LMOperatorInfo,
  LMTypeOperatorOptionState,
} from "@modal/field-picker/lm-field-picker";
import { LMFieldPickerService } from "@app/components";
import { LMGlobalPersonalizationService } from "@app/states";

@Component({
  selector: 'lm-field-picker-field-operator',
  templateUrl: './lm-field-picker-field-operator.component.html',
  styleUrls: [ './lm-field-picker.component.scss' ],
  providers: [ LMRouteComponentService ]
  })
export class LMFieldPickerFieldOperatorComponent implements OnInit {

  @Input() uiFieldSpec!: UIFieldSpec;
  @Input() operatorInfo!: LMOperatorInfo;
  @Input() auditData: false | undefined;

  @Output() operatorChangedEvent = new EventEmitter<FieldOperatorChangedEvent>();

  useCompactFormLayout = false;
  fieldOperators: Array<LMFieldOperatorOptionState> | undefined;
  typeOperators: Array<LMTypeOperatorOptionState> | undefined;
  formatStyles: Array<LMFormatStyleOptionState> | undefined;

  constructor(
    private lmFieldPickerService: LMFieldPickerService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
  ) {
    // @ts-ignore
    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout ? this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout : false;
  }
  ngOnInit() {
    this.fieldOperators = this.lmFieldPickerService.buildFieldOperatorOptions(this.auditData || false, this.uiFieldSpec);
    this.typeOperators  = this.lmFieldPickerService.buildTypeOperatorOptions(this.uiFieldSpec);
    this.formatStyles   = this.lmFieldPickerService.buildFieldStyleOptions(this.uiFieldSpec);
  }
  onOperatorChange(eventType?: 'field' | 'type') {
    if ('type' === eventType) {
      const info = this.operatorInfo.typeOperatorInfo;
      if (info) {
        info.asOfDate = undefined;
        info.splitOn = ',';
        info.useFullName = undefined,
        info.useShortName = false;
        info.javaFormat = undefined;
        info.formatStyle = 'short';
        info.withShortDayName = false;
        info.withDayName = false;
        info.showTimeZone = false;
        info.hideSeconds = false;
        info.usingTimeZone = 'using user time zone';
      }
    }

    const event:FieldOperatorChangedEvent = {
      eventType: 'field' === eventType ? 'field' : 'type',
      uiFieldSpec: this.uiFieldSpec,
      operatorInfo: this.operatorInfo
    };

    this.operatorChangedEvent.emit(event);

  }
}

